<template>
  <base-show
    :fields="fields"
    :resourceName="resourceName"
    :pk="pk"
    :breadcrumbs="breadcrumbs"
    >
    <template slot="histories" slot-scope="{ input }">
      <CListGroup>
        <CListGroupItem v-for="(histories, index) in input" :key="'process' + index"
                        style="border: 0;font-weight: bold">
          {{histories}}
        </CListGroupItem>
      </CListGroup>
    </template>
    <template slot="duplicated" slot-scope="{ input }">
      <CAlert color="danger" v-if="input === 1">
        同一の依頼者から過去に本商品のサンプルの依頼を受けています。
      </CAlert>
    </template>
    <template slot="user" slot-scope="{ input }">
      <CListGroup>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">
          会員属性：{{optionName('common/user_types', input['user_type'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">
          性別：{{optionName('common/genders', input['sex'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">
          生年月日：{{input['birth_date']}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">
          店舗所在地(大)：{{optionName('common/large_locations', input['large_location'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">
          店舗所在地(中)：{{optionName('common/medium_locations', input['medium_location'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">
          店舗業態(大)：{{optionName('common/biz_large_categories', input['biz_large_category'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">
          店舗業態(中)：{{optionName('common/biz_medium_categories', input['biz_medium_category'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">
          店舗規模(店舗数)：{{optionName('common/business_scales', input['business_scale'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">
          主要店舗展開エリア：{{optionName('common/business_areas', input['business_area'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">
          ランチ営業有無：{{optionName('common/lunch_menus', input['lunch_menu'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">
          会員状態：{{optionName('common/plan_nums', input['plan_num'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">
          最終ログイン日時：{{input['logged_in_at']}}
        </CListGroupItem>
      </CListGroup>
    </template>
  </base-show>
</template>

<script>
export default {
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    const vm = this;

    return {
      resourceName: "requests",
      fields: [
        [
          {
            label: "",
            name: "duplicated",
            long: true,
            type: "custom"
          },
          {
            label: "依頼ID",
            name: "request_id",
            long: true
          },
          {
            label: "商品ID",
            name: "product_code",
          },
          {
            label: "商品画像",
            name: "images",
            type: "images",
            long: true
          },
          {
            label: "商品名",
            name: "name",
          },
          {
            label: "ユーザー名",
            name: "user_name",
          },
          {
            label: "送付先名称",
            name: "destination_name",
          },
          {
            label: "郵便番号",
            name: "zip_code",
          },
          {
            label: "店舗住所",
            name: "address",
          },
          {
            label: "電話番号",
            name: "telephone",
          },
          {
            label: "既存取引先情報",
            name: "existing_suppliers",
          },
          {
            label: "対応履歴",
            name: "histories",
            long: true,
            type: "custom"
          },
          {
            label: "ユーザー属性情報",
            name: "user",
            long: true,
            type: "custom"
          }
        ]
      ]
    };
  },
  computed: {
    entity() {
      return this.$store.getters[`${this.resourceName}/entity/entity`];
    },
    breadcrumbs() {
      return [
        {
          text: this.isProvider ? "商品サンプル依頼一覧" : "依頼一覧",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: this.isProvider ? "商品サンプル依頼詳細" : "依頼詳細",
          disabled: true
        }
      ];
    },
    optionName() {
      return (optionName, value) => {
        const options =
          this.$store.getters[`${optionName}/options/options`] || [];
        return (options.find(v => v.value === value) || {}).label;
      };
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  },
  watch: {
    "entity.user.large_location": {
      handler(value) {
        if (value !== null) {
          this.$store.dispatch(
            `common/medium_locations/options/index`,
            value
          );
        }
      }
    },
    "entity.user.biz_large_category": {
      handler(value) {
        if (value !== null) {
          this.$store.dispatch(
            `common/biz_medium_categories/options/index`,
            value
          );
        }
      }
    },
  },
  created(){
    this.$store.dispatch(`common/user_types/options/index`);
    this.$store.dispatch(`common/genders/options/index`);
    this.$store.dispatch(`common/large_locations/options/index`);
    this.$store.dispatch(`common/biz_large_categories/options/index`);
    this.$store.dispatch(`common/business_scales/options/index`);
    this.$store.dispatch(`common/business_areas/options/index`);
    this.$store.dispatch(`common/lunch_menus/options/index`);
    this.$store.dispatch(`common/plan_nums/options/index`);
  }
};
</script>

<style scoped lang="scss">
.list-group-item {
  padding: 0.75rem 4px;
}
</style>